import React from "react";
import { demoDestinations } from "../components/DestinationsSection";
import "./DestinationPages.css";

const IndiaDestinations = () => {
  return (
    <div className="dest-page">
      <h2>Featured Destinations in India</h2>
      <div className="dest-grid">
        {demoDestinations.map((place) => (
          <div key={place.id} className="dest-card">
            <img src={place.images[0]} alt={place.title} />
            <h3>{place.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndiaDestinations;
